"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app = require('ayvri-viewer/lib/App').default;
const api = require('ayvri-viewer/lib/services/api');
exports.api = api;
const actions = require('ayvri-viewer/lib/actions');
exports.setTime = actions.setTime;
exports.addPoints = actions.addPoints;
exports.togglePlaying = actions.togglePlaying;
exports.addSegment = actions.addSegment;
exports.updateSegment = actions.updateSegment;
exports.deleteSegment = actions.deleteSegment;
exports.addMedia = actions.addMedia;
exports.deleteMedia = actions.deleteMedia;
exports.incrementAltitudeOffset = actions.incrementAltitudeOffset;
exports.setClockSpeed = actions.setClockSpeed;
exports.setCameraDistance = actions.setCameraDistance;
exports.setTarget = actions.setTargetPointsById;
const store = require('ayvri-viewer/lib/store').default;
exports.viewerStore = store;
exports.SceneClass = require('ayvri-viewer/lib/classes/scene').default;
exports.Player = require('ayvri-viewer/lib/components/player/Player').default;
if (typeof window !== 'undefined' && !window.app) {
    // Bootstrap the app
    window.app = new app();
    const success = window.app.initialize();
    const renderLoop = (timestamp) => {
        window.app.tick(timestamp);
        if (typeof requestAnimationFrame !== 'undefined') {
            requestAnimationFrame(renderLoop);
        }
    };
    if (success) {
        renderLoop(0);
    }
}
if (typeof window !== 'undefined' && !window.api) {
    window.api = api;
}
function setupScene(scene) {
    if (typeof typeof window !== 'undefined') {
        return window.app.onSceneLoad(scene);
    }
    return undefined;
}
exports.setupScene = setupScene;
